import { render } from "./ClockView.vue?vue&type=template&id=18405484"
import script from "./ClockView.vue?vue&type=script&lang=js"
export * from "./ClockView.vue?vue&type=script&lang=js"

import "./ClockView.vue?vue&type=style&index=0&id=18405484&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__